module.exports = __webpack_public_path__ + "img/facebook.3ac49eb8.svg";